module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "email",
    class: {
      email_padding: _vm.padding
    }
  }, [(!_vm.user.profile.is_verified && !_vm.$v.user.profile.email.$invalid) ? _c('div', {
    staticClass: "email__message"
  }, [_c('span', {
    staticClass: "email__text"
  }, [_vm._v("Пожалуйста, подтвердите электронную почту: "), _c('b', [_vm._v(_vm._s(_vm.email))])])]) : _vm._e(), (!_vm.user.profile.is_verified && _vm.$v.user.profile.email.$invalid) ? _c('div', {
    staticClass: "email__message"
  }, [_c('span', {
    staticClass: "email__text"
  }, [_c('b', [_vm._v("Внимание!")]), _vm._v(" Уведомления по заявкам "), _c('b', [_vm._v("не направляются на почту")]), _vm._v(" с доменом " + _vm._s(_vm.getMessageByInsertedEmail(_vm.user.profile.email)) + ". Укажите другой адрес.")])]) : _vm._e(), (_vm.user.profile.is_verified && _vm.$v.user.profile.email.$invalid) ? _c('div', {
    staticClass: "email__message"
  }, [_c('b', [_vm._v("Внимание!")]), _vm._v(" Уведомления по заявкам не направляются на почту с доменом " + _vm._s(_vm.getMessageByInsertedEmail(_vm.user.profile.email)) + ". Обратитесь в ЦОПП или учебное заведение, где вы учитесь на данный момент, для смены e-mail.")]) : _vm._e(), (!_vm.user.profile.is_verified && !_vm.$v.user.profile.email.$invalid) ? _c('div', {
    staticClass: "email__buttons"
  }, [(_vm.EmailService) ? _c('a', {
    staticClass: "email__btn email__btn_check",
    attrs: {
      "target": "_blank",
      "href": _vm.EmailService
    }
  }, [_vm._v("Проверить входящие")]) : _vm._e(), _c('button', {
    staticClass: "email__btn email__btn_resend",
    class: {
      email__btn_disabled: _vm.isDisabled
    },
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": function($event) {
        return _vm.$emit("resend")
      }
    }
  }, [_vm._v("Письмо подтверждения")])]) : _vm._e(), (_vm.user.profile.is_verified && _vm.$v.user.profile.email.$invalid) ? _c('div', {
    staticClass: "email__buttons"
  }, [_c('button', {
    staticClass: "email__btn email__btn_resend",
    attrs: {
      "disabled": !!_vm.isDisabled
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Понятно!")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4751a9d7","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/emailconfirm/Confirm.vue
// module id = 1352228f684f479d5a18
// module chunks = 0